export default "__VITE_ASSET__BS$wo5hZ__"